export const workerMenuItems = ({ locationId }) => [
  {
    pathname: `/customers${locationId ? `?locationId=${locationId}` : ''}`,
    translation: 'components.header.menu-items.worker.offers',
    defaultMessage: 'Offers',
    isMobile: false,
  },
  {
    pathname: '/chats',
    translation: 'components.header.menu-items.worker.chats',
    defaultMessage: 'Chats',
    isMobile: false,
  },
  {
    pathname: '/favorites',
    translation: 'components.header.menu-items.worker.favorites',
    defaultMessage: 'Favorites',
    isMobile: false,
  },
  {
    pathname: '/account',
    translation: 'components.header.menu-items.worker.profile',
    defaultMessage: 'Profile',
    isMobile: false,
  },
  {
    pathname: '/settings',
    translation: 'components.header.menu-items.worker.settings',
    defaultMessage: 'Settings',
    isMobile: false,
  },
  {
    pathname: '/contact',
    translation: 'components.header.menu-items.worker.contact',
    defaultMessage: 'Contact',
    isMobile: false,
  },
  {
    pathname: '/veelgestelde-vragen',
    translation: 'components.header.menu.faq',
    defaultMessage: 'FAQ',
    isMobile: true,
    onlyDropdown: true,
  },
  {
    pathname: '/algemene-voorwaarden',
    translation: 'components.footer.copyright.terms-and-conditions',
    defaultMessage: 'Terms and conditions',
    isMobile: true,
    onlyDropdown: true,
  },
  {
    pathname: '/privacybeleid',
    translation: 'components.footer.copyright.privacy-policy',
    defaultMessage: 'Privacy policy',
    isMobile: true,
    onlyDropdown: true,
  },
];

export const clientMenuItems = ({ locationId }) => [
  {
    pathname: `/workers${locationId ? `?locationId=${locationId}` : ''}`,
    translation: 'components.header.menu-items.client.offers',
    defaultMessage: 'Offers',
    isMobile: false,
  },
  {
    pathname: '/chats',
    translation: 'components.header.menu-items.client.chats',
    defaultMessage: 'Chats',
    isMobile: false,
  },
  {
    pathname: '/favorites',
    translation: 'components.header.menu-items.client.favorites',
    defaultMessage: 'Favorites',
    isMobile: false,
  },
  {
    pathname: '/account',
    translation: 'components.header.menu-items.client.profile',
    defaultMessage: 'Profile',
    isMobile: false,
  },
  {
    pathname: '/settings',
    translation: 'components.header.menu-items.client.settings',
    defaultMessage: 'Settings',
    isMobile: false,
  },
  {
    pathname: '/contact',
    translation: 'components.header.menu-items.client.contact',
    defaultMessage: 'Contact',
    isMobile: false,
  },
  {
    pathname: '/veelgestelde-vragen',
    translation: 'components.header.menu.faq',
    defaultMessage: 'FAQ',
    isMobile: true,
    onlyDropdown: true,
  },
  {
    pathname: '/algemene-voorwaarden',
    translation: 'components.footer.copyright.terms-and-conditions',
    defaultMessage: 'Terms and conditions',
    isMobile: true,
    onlyDropdown: true,
  },
  {
    pathname: '/privacybeleid',
    translation: 'components.footer.copyright.privacy-policy',
    defaultMessage: 'Privacy policy',
    isMobile: true,
    onlyDropdown: true,
  },
];
